// Google Ads click ids that auto-tagging appends to the landing URL
// (operator, 10.10.2026). Read once, when this module first runs in the
// browser, i.e. on the page the ad opened, and kept only in memory: nothing
// is stored on the device before the visitor consents. Without this, a
// visitor who clicks on to another page before accepting the cookie notice
// loses the id, and a later booking is never credited to the ad (tested live
// on 10.10.2026).

const CLICK_IDS = ["gclid", "gbraid", "wbraid", "dclid"] as const;
const CLICK_PARAMS = [...CLICK_IDS, "gad_source", "gad_campaignid"] as const;

const landingParams: [string, string][] =
  typeof window === "undefined"
    ? []
    : CLICK_PARAMS.flatMap((k) => {
        const v = new URLSearchParams(window.location.search).get(k);
        return v ? [[k, v] as [string, string]] : [];
      });

/** True if this visit started with a click on a Google ad. */
export function cameFromAd(): boolean {
  return landingParams.some(([k]) => (CLICK_IDS as readonly string[]).includes(k));
}

/** The ad parameters of the landing URL that the current URL no longer has. */
export function missingClickParams(): [string, string][] {
  if (typeof window === "undefined" || !cameFromAd()) return [];
  const now = new URLSearchParams(window.location.search);
  return landingParams.filter(([k]) => !now.has(k));
}
